import UI from "@mile-meeting/mile-ui";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import { TRestrictRequest } from "apis/meetings/block-request";

type RequestTableProps = {
  data: TRestrictRequest[];
  onOpenDetailModal: (data: TRestrictRequest) => void;
  onCancel: (data: TRestrictRequest) => void;
};

const RequestTable = ({ data, onOpenDetailModal, onCancel }: RequestTableProps) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <TableHeader />
      {data.length === 0 && <EmptyRow />}
      {data.length !== 0 &&
        data
          .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
          .map((item) => (
            <TableRow
              data={item}
              onClick={() => {
                onOpenDetailModal(item);
              }}
              onCancel={() => {
                onCancel(item);
              }}
            />
          ))}
    </div>
  );
};

export default RequestTable;

const EmptyRow = () => {
  return (
    <div
      style={{
        display: "flex",
        padding: "12px 24px",
        gap: 8,
        alignItems: "center",
        borderBottom: "1px solid var(--alias-color-line-normal",
      }}
    >
      <UI.Icon name="removeCircle" color="var(--alias-color-label-alternative)" />
      <UI.Typography type="body01 normal" fontStyle="regular">
        회의실 예약 제한 요청 내역이 없습니다.
      </UI.Typography>
    </div>
  );
};
